import { Icon } from "@iconify/react/dist/iconify.js";
import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    InputHTMLAttributes,
    useState,
} from "react";

export default forwardRef(function PasswordInput(
    {
        type = "text",
        className = "",
        isFocused = false,
        hasError = "",
        ...props
    }: InputHTMLAttributes<HTMLInputElement> & {
        isFocused?: boolean;
        hasError?: string;
    },
    ref,
) {
    const localRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => ({
        focus: () => localRef.current?.focus(),
    }));

    useEffect(() => {
        if (isFocused) {
            localRef.current?.focus();
        }
    }, []);

    const [isPasswordType, setIsPasswordType] = useState<boolean>(true);

    return (
        <div
            className={`relative ${props["required"] ? "maxMd:max-w-[calc(100%_-_16px)]" : ""}`}
        >
            {localRef.current?.value && (
                <label className="text-arcticMist text-12 leading-16 absolute left-4 top-2">
                    {props["placeholder"]}
                </label>
            )}
            {props["required"] && (
                <div
                    className={`absolute -right-7 top-5 maxMd:-right-6 text-arcticMist`}
                >
                    <Icon
                        icon={`lucide:asterisk`}
                        width={24}
                        height={24}
                        className={`cursor-pointer transition-theme`}
                    />
                </div>
            )}
            <input
                {...props}
                type={`${isPasswordType ? "password" : "text"}`}
                className={`input-default ${className} ${localRef.current?.value ? "filled-input" : ""} ${hasError ? "border-crimsonAlert" : "border-royalPeriwinkle"}`}
                ref={localRef}
            />
            <button
                type="button"
                onClick={() => setIsPasswordType((prev) => !prev)}
            >
                <Icon
                    icon={`${isPasswordType ? "ph:eye-bold" : "ph:eye-slash-bold"}`}
                    className={`${hasError ? "text-crimsonAlert" : "text-royalPeriwinkle"} w-6 h-6 absolute right-4 top-1/2 -translate-y-1/2`}
                />
            </button>
        </div>
    );
});
